var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.6 37.5h-15c-3.1 0-5.7-2.5-5.7-5.7V10.7C8 7.6 10.5 5 13.7 5h15.2c3.1 0 5.7 2.5 5.7 5.7v21.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M13.8 23.4h14.6M13.8 29.7h14.6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 13.8,
    cy: 12.7,
    r: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSaved);
export default __webpack_public_path__ + "static/media/documentSaved.3ae16ce97102920c1acc40e7bd5fe029.svg";
export { ForwardRef as ReactComponent };